var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SubPage", {
    attrs: { pageMode: _vm.pageMode, onSwitchMode: _vm.onSwitchMode },
    scopedSlots: _vm._u([
      {
        key: "main_page",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass: "dashboard-container container-fix-padding",
                attrs: { fluid: "" },
              },
              [
                _c("div", { staticClass: "d-flex" }, [
                  _c(
                    "div",
                    { staticClass: "dashboard-container-item col-sm-9 p-0" },
                    [
                      _vm.getBanner("user_dashboard_top")
                        ? [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getBanner("user_dashboard_top").bodyHtml
                                ),
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "bg-white p-2" }, [
                        _vm.mobile
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c("DashboardProgress", {
                                    staticClass: "w-50",
                                    attrs: {
                                      progressRate: _vm.learnProgressRate,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "w-50" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center justify-space-between mb-2",
                                        },
                                        [
                                          _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "text-overline" },
                                              [_vm._v("今週の学習")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "fw-bold" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.learnTimeToTimeJp
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("UserTimeGoalChangeDialog", {
                                            attrs: {
                                              update: _vm.updateTimeGoal,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("DashboardTimeSummary", {
                                        staticClass: "d-flex align-end",
                                        attrs: {
                                          height: 70,
                                          width: 100,
                                          timeGraphData: _vm.timeGraphData,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex border-top border-bottom",
                                },
                                [
                                  _c("div", { staticClass: "w-33 pe-2 py-2" }, [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-center" },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("mdi-clock-time-five-outline"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "ms-1 text-caption" },
                                          [_vm._v("学習時間")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text-align-right" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.mobile
                                              ? "text-h7"
                                              : "text-h4",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.totalLearnTimeToTimeJp)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "w-33 border-left px-2 py-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex align-center" },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [
                                              _vm._v(
                                                "mdi-file-document-multiple-outline"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "ms-1 text-caption",
                                            },
                                            [_vm._v("Act数")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "text-align-right" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-h4" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.computedActivityCount
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-caption" },
                                            [_vm._v("回")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "w-33 border-left ps-2 py-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex align-center" },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [
                                              _vm._v(
                                                "mdi-file-document-multiple"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "ms-1 text-caption",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.customTexts.get(
                                                    "classroom_dashboard.consecutive_days"
                                                  ) || "連続日数"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "text-align-right" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-h4" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.consecutiveDayCount)
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-caption" },
                                            [_vm._v("日")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex pt-2 justify-space-between align-center px-3",
                                  on: { click: _vm.toActivity },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex" },
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-file-chart-outline"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-overline ms-1" },
                                        [_vm._v("学習レポート")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                  >\n                "
                                    ),
                                  ]),
                                ]
                              ),
                            ])
                          : _c("div", { staticClass: "d-flex" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "w-37",
                                  style: { minWidth: "320px" },
                                },
                                [
                                  _c(
                                    "DashboardProgress",
                                    {
                                      attrs: {
                                        progressRate: _vm.learnProgressRate,
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.customTexts.get(
                                              "classroom_dashboard.this_week_goal"
                                            ) || "今週目標"
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "fw-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.learnTimeToTimeJp)
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("UserTimeGoalChangeDialog", {
                                            attrs: {
                                              update: _vm.updateTimeGoal,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mt-2" }, [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customTexts.get(
                                                "classroom_dashboard.this_week_learning"
                                              ) || "今週の学習"
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "fw-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.totalLearnTimeToTimeJp
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-32 border-left px-3" },
                                [
                                  _c("DashboardTimeSummary", {
                                    attrs: { timeGraphData: _vm.timeGraphData },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-row justify-space-between align-center",
                                    },
                                    [
                                      _c("div", { staticClass: "text-08rem" }, [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.dateFormat(
                                                _vm.dateRange.startDate
                                              )
                                            ) +
                                            " 〜 " +
                                            _vm._s(
                                              _vm.dateFormat(
                                                _vm.dateRange.endDate
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "ms-3" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                "x-small": "",
                                                color: "primary",
                                                dark: "",
                                              },
                                              on: { click: _vm.toActivity },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      詳細見る\n                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "w-30 border-left" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ps-3 h-50 d-flex justify-space-between flex-column pb-2",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-center" },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v(
                                            "mdi-file-document-multiple-outline"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "ms-1 text-caption" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.customTexts.get(
                                                  "classroom_dashboard.total_completed_count"
                                                ) || "学習完了数"
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("span", { staticClass: "text-h4" }, [
                                        _vm._v(
                                          _vm._s(_vm.computedActivityCount)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-caption" },
                                        [_vm._v("回")]
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ps-3 border-top h-50 pt-2 d-flex justify-space-between flex-column",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-center" },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("mdi-file-document-multiple"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "ms-1 text-caption" },
                                          [_vm._v("連続日数")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("span", { staticClass: "text-h4" }, [
                                        _vm._v(_vm._s(_vm.consecutiveDayCount)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-caption" },
                                        [_vm._v("日")]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                      ]),
                      _vm._v(" "),
                      _vm.user && _vm.user.showDashboardInformation
                        ? _c("div", { staticClass: "p-3 mt-3 bg-white" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex justify-space-between",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-x-large font-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.user.showDashboardInformation
                                              .title
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-small ms-2 border-default p-1 text-blue cursor-pointer",
                                        on: {
                                          click: function ($event) {
                                            return _vm.readInformation(
                                              _vm.user.showDashboardInformation
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  非表示にする\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-divider", { staticClass: "mt-2" }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "bg-white px-2 py-1 mt-2 info-content",
                                  },
                                  [
                                    _c("p", {
                                      staticClass: "my-3 html-body",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.user.showDashboardInformation
                                            .content
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.unreadInformations.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "p-3 mt-3",
                              staticStyle: { background: "#FFFFF0" },
                            },
                            [
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex justify-space-between",
                                  },
                                  [
                                    _c("div", { staticClass: "text-large" }, [
                                      _vm._v("お知らせ"),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "text-small" }, [
                                      _vm._v(
                                        "未読: " +
                                          _vm._s(
                                            _vm.user.unreadInformationsCount
                                          ) +
                                          "件"
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "bg-white border-default px-2 py-1 mt-2",
                                  },
                                  [
                                    _vm._l(
                                      _vm.latestiUnreadInformations,
                                      function (item, index) {
                                        return [
                                          _c("InformationView", {
                                            key: "item-" + item.id,
                                            attrs: { item: item },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.toInfo(item)
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          index <
                                          _vm.latestiUnreadInformations.length -
                                            1
                                            ? _c("v-divider", {
                                                key: "divider-" + item.id,
                                              })
                                            : _vm._e(),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "d-flex justify-end mt-1" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "text-blue cursor-pointer",
                                        attrs: { to: "/classroom/infors" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  すべてのお知らせを見る\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentUserGoal
                        ? _c("div", { staticClass: "bg-white p-3 mt-3" }, [
                            _c(
                              "h3",
                              { staticClass: "gray--text font-weight-bold" },
                              [
                                _c("v-icon", { staticClass: "me-1" }, [
                                  _vm._v("mdi-bullseye-arrow"),
                                ]),
                                _vm._v(
                                  _vm._s(
                                    _vm.customTexts.get(
                                      "classroom_dashboard.goal"
                                    ) || "ゴール"
                                  ) + "\n            "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-3 col-sm-12" },
                                [
                                  _c("v-img", {
                                    attrs: {
                                      src: _vm.currentUserGoal.goal.image.url,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-h6",
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.goToUserGoal(
                                          _vm.currentUserGoal
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.currentUserGoal.goal.name) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-2 mb-1" }, [
                                  _vm._v(
                                    "\n                  目標期間 " +
                                      _vm._s(
                                        _vm.dateFormat(
                                          _vm.userGoal.startDate,
                                          "YYYY/MM/DD"
                                        )
                                      ) +
                                      "～" +
                                      _vm._s(
                                        _vm.dateFormat(
                                          _vm.userGoal.endDate,
                                          "YYYY/MM/DD"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _vm.userGoal.isOutSchedule
                                          ? _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  color: "red",
                                                  "text-color": "white",
                                                  small: _vm.mobile,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      遅れてます\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm.userGoal.isLate
                                          ? _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  color: "green",
                                                  "text-color": "white",
                                                  small: _vm.mobile,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      やや遅れています\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm.userGoal.isOnSchedule
                                          ? _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  color: "primary",
                                                  small: _vm.mobile,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      順調\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "font-bold ms-2" },
                                      [
                                        _vm._v(
                                          "\n                    残り日数" +
                                            _vm._s(_vm.userGoal.daysRemaining) +
                                            "日\n                  "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-row align-self-center justify-content-center",
                                  },
                                  [
                                    _c(
                                      "v-progress-circular",
                                      {
                                        attrs: {
                                          rotate: 270,
                                          size: 150,
                                          width: 20,
                                          value: _vm.userGoal.progressRate,
                                          color: "primary",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "line-height": "1",
                                              "text-align": "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "xx-large",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.userGoal.progressRate
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            _vm._v("%\n                    "),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-2 text-center" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customTexts.get(
                                        "classroom_dashboard.progress_rate"
                                      ) || "進捗率"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.totalUserGoalsCount() > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mt-2 text-center text-blue cursor-pointer",
                                        on: { click: _vm.goToUserGoals },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  ゴール他" +
                                            _vm._s(_vm.totalUserGoalsCount()) +
                                            "つを全部見る\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "bg-white p-3 mt-3" }, [
                        _c(
                          "div",
                          [
                            _vm.firstEnrollments.length > 0
                              ? [
                                  _c("h3", { staticClass: "gray--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customTexts.get(
                                          "classroom_dashboard.class_in_progress"
                                        ) || "授業中の講座"
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.firstEnrollments,
                                    function (enrollment) {
                                      return [
                                        _c("v-divider", {
                                          key: "divider-" + enrollment.id,
                                        }),
                                        _vm._v(" "),
                                        _c("CourseMy", {
                                          key: enrollment.id,
                                          attrs: { enrollment: enrollment },
                                        }),
                                      ]
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.isMoreCourse
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-end mt-4 me-4",
                                          },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "show-more",
                                                attrs: {
                                                  to: "/classroom/my-courses",
                                                },
                                              },
                                              [_vm._v("もっと見る")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              : [
                                  _c("h3", { staticClass: "gray--text" }, [
                                    _vm._v("まだ受講中の講座はありません"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "exams-list",
                                      attrs: { href: "/courses" },
                                    },
                                    [_vm._v("講座一覧を見る")]
                                  ),
                                ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt-5" },
                          [
                            _vm.exams.length > 0
                              ? [
                                  _c("h3", { staticClass: "gray--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customTexts.get(
                                          "classroom_dashboard.recent_tests"
                                        ) || "最近受けたテスト"
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.exams.slice(0, 3),
                                    function (exam, index) {
                                      return _c(
                                        "div",
                                        { key: index },
                                        [
                                          _c("Exam", {
                                            attrs: {
                                              exam: exam,
                                              isMine: true,
                                              schoolSetting: _vm.schoolSetting,
                                              onShowHistories:
                                                _vm.onShowHistories,
                                            },
                                            on: { fetchList: _vm.refetchList },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.isMoreExam
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-end mt-3 me-4",
                                          },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "show-more",
                                                attrs: {
                                                  to: "/classroom/my-exams",
                                                },
                                              },
                                              [_vm._v("もっと見る")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              : [
                                  _c("h3", { staticClass: "gray--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customTexts.get(
                                          "classroom_dashboard.no_test_results"
                                        ) || "まだテスト結果はありません"
                                      ) +
                                        " " +
                                        _vm._s(_vm.exams.length)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "exams-list",
                                      attrs: { href: "/exams" },
                                    },
                                    [_vm._v("テスト一覧を見る")]
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.getBanner("user_dashboard_bottom")
                        ? _c("div", { staticClass: "col-sm-2" }, [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getBanner("user_dashboard_bottom")
                                    .bodyHtml
                                ),
                              },
                            }),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.getBanner("user_dashboard_sidebar_top")
                    ? _c("div", { staticClass: "col-sm-2" }, [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getBanner("user_dashboard_sidebar_top")
                                .bodyHtml
                            ),
                          },
                        }),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "sub_page",
        fn: function () {
          return [
            _vm.subPageExam
              ? _c("Exam", {
                  attrs: {
                    exam: _vm.subPageExam,
                    isMine: true,
                    schoolSetting: _vm.schoolSetting,
                  },
                  on: { fetchList: _vm.refetchList },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }